import { useState } from 'react'

import { FvLinkButton } from '@fv/client-components'

import { DividedContent } from '@/components/DividedContent'
import InfoBox from '@/components/InfoBox'
import UploadDocumentField from '@/components/inputs/UploadDocumentField'

import { HasPermission } from '../auth'
import DocumentList from '../documents/DocumentList'
import {
  SliderContentBody,
  SliderContentFooter,
  SliderContentHeader,
} from './SliderContentLayout'
import type { DetailsDocumentPanelProps, ShipmentContentProps } from './types'

export const DetailsDocumentPanel = ({
  setActiveSlider,
  load,
  uploadFileType,
}: DetailsDocumentPanelProps & ShipmentContentProps) => {
  const [showUploadForm, setShowUploadForm] = useState(!!uploadFileType)
  const { documents, loadId, locations, bol } = load
  return (
    <>
      <SliderContentBody>
        <SliderContentHeader
          {...{ loadId, locations, bol }}
          prefix="Documents for"
          noBorder
        />

        <InfoBox>
          <p className="!leading-[1.6rem] mb-0">
            Current documents are shown below. To upload a new file select 'Add
            document' below.
          </p>
        </InfoBox>

        <DocumentList
          className="mb-6"
          canDelete={true}
          {...{ documents, loadId }}
        />
      </SliderContentBody>
      <HasPermission name="load-file-manager">
        <SliderContentFooter>
          {!showUploadForm ? (
            <DividedContent theme="blue" className="!justify-center">
              <FvLinkButton
                onClick={() => setActiveSlider('share')}
                icon="share"
              >
                Share
              </FvLinkButton>
              <FvLinkButton
                onClick={() => setShowUploadForm(true)}
                icon="upload"
              >
                Add document
              </FvLinkButton>
            </DividedContent>
          ) : (
            <UploadDocumentField
              handleClose={() => setActiveSlider(undefined)}
              loadId={load.loadId}
              requireDocType
              defaultDocType={uploadFileType}
            />
          )}
        </SliderContentFooter>
      </HasPermission>
    </>
  )
}
